export const ID_YOUTUBE_IFRAME_SCRIPT = 'YoutubeIframeScript';
